export default function findAndScrollToSection(textLayer, section, pageElement) {
  const sectionNumber = section.sectionNumber || '';
  const sectionTitle = section.title || '';
  const fullTitle = section.fullTitle || '';

  const allText = textLayer.textContent || '';
  const sectionIndex = allText.indexOf(sectionNumber);
  const textSpans = textLayer.querySelectorAll('span');

  let foundElement = null;

  if (sectionIndex !== -1) {
    let charCount = 0;
    for (const span of textSpans) {
      const spanText = span.textContent || '';
      const spanStart = charCount;
      const spanEnd = charCount + spanText.length;

      if (sectionIndex >= spanStart && sectionIndex < spanEnd) {
        foundElement = span;
        break;
      }
      charCount += spanText.length;
    }
  }

  if (!foundElement) {
    const sectionNumberPattern = sectionNumber.replace(/\./g, '\\.') ;
    for (const span of textSpans) {
      const text = span.textContent?.trim() || '';
      if (text.startsWith(sectionNumber) ||
        text.match(new RegExp(`^${sectionNumberPattern}\\s`, 'i')) ||
        text.includes(sectionNumber + ' ') ||
        text.includes(sectionNumber + '.')) {
        foundElement = span;
        break;
      }
    }
  }

  if (!foundElement && sectionTitle && sectionTitle.length > 2) {
    for (const span of textSpans) {
      const text = span.textContent?.trim() || '';
      if (text.includes(sectionTitle) && text.length < 150) {
        foundElement = span;
        break;
      }
    }
  }

  if (!foundElement && fullTitle) {
    let accumulatedText = '';
    let startSpan = null;
    let spanCount = 0;
    const maxSpans = 20;

    for (const span of textSpans) {
      if (spanCount >= maxSpans) break;
      if (!startSpan) startSpan = span;
      accumulatedText += span.textContent || '';
      spanCount++;

      const normalizedAccumulated = accumulatedText.replace(/\s+/g, ' ').trim();
      const normalizedSectionNumber = sectionNumber.replace(/\s+/g, ' ').trim();
      const normalizedFullTitle = fullTitle.replace(/\s+/g, ' ').trim();

      if (normalizedAccumulated.includes(normalizedSectionNumber) ||
        normalizedAccumulated.includes(normalizedFullTitle.substring(0, Math.min(20, normalizedFullTitle.length)))) {
        foundElement = startSpan;
        break;
      }

      if (accumulatedText.length > fullTitle.length * 3) {
        accumulatedText = '';
        startSpan = null;
        spanCount = 0;
      }
    }
  }

  if (!foundElement) {
    const normalizedAllText = allText.replace(/\s+/g, ' ').trim();
    const normalizedSectionNumber = sectionNumber.replace(/\s+/g, ' ').trim();
    const normalizedIndex = normalizedAllText.indexOf(normalizedSectionNumber);

    if (normalizedIndex !== -1) {
      let originalIndex = 0;
      let normalizedCount = 0;
      for (let i = 0; i < allText.length && normalizedCount < normalizedIndex; i++) {
        if (!/\s/.test(allText[i]) || (i > 0 && !/\s/.test(allText[i - 1]))) {
          normalizedCount++;
        }
        originalIndex = i;
      }

      let charCount = 0;
      for (const span of textSpans) {
        const spanText = span.textContent || '';
        if (charCount + spanText.length >= originalIndex) {
          foundElement = span;
          break;
        }
        charCount += spanText.length;
      }
    }
  }

  if (foundElement) {
    try {
      foundElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    } catch {
      const parent = foundElement.parentElement;
      if (parent) {
        parent.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }
  } else {
    pageElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
}
